// 계정 관리 관련 서비스
import { apiClient } from "./api";

/**
 * 회원 탈퇴 요청
 */
export const deleteAccount = async (): Promise<void> => {
  await apiClient.delete("/users");

  // 회원 탈퇴 성공 시 로컬 스토리지 정리
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("userInfo");
};
